module.exports = "pegasus/assets/theme3/facebook.png";